// extracted by mini-css-extract-plugin
export default {"floatingChatButton":"ChatButton_floatingChatButton__nVJ+T","pulse":"ChatButton_pulse__F2UXW","iconWrap":"ChatButton_iconWrap__lU6NB","tooltip":"ChatButton_tooltip__Kl0io"};